export default function observeVisibleImpression(element, onImpression) {
  const document = element.ownerDocument;
  const browser = document.defaultView;
  let timer;
  let inViewport = false;
  let recorded = false;
  const check = () => {
    browser.clearTimeout(timer);
    if (!recorded && inViewport && document.visibilityState === 'visible') {
      timer = browser.setTimeout(() => {
        recorded = true;
        onImpression();
      }, 1000);
    }
  };
  const observer = new browser.IntersectionObserver(([entry]) => {
    inViewport = entry.isIntersecting && entry.intersectionRatio >= 0.5;
    check();
  }, { threshold: 0.5 });
  observer.observe(element);
  document.addEventListener('visibilitychange', check);
  return () => {
    browser.clearTimeout(timer);
    observer.disconnect();
    document.removeEventListener('visibilitychange', check);
  };
}
